<template>
  <div class="m-activity-seckill-buyerRecord">
    <Search :renderData="renderData" :formData="searchForm" @onSearch="onSearch" :labelWidth="120" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #couponName="{ row }">{{ row.couponName }}</template>
      <template #couponKind="{ row }">{{ couponKindMap[row.couponKind] }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #status="{ row }">{{ onType(row.status)}}</template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getSeckillCouponBuyRecordList, api_getActivityRecordExport } from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import Table from "@/components/Table/index";
import Search from "@/components/Search/index";

export default {
  name: "marketActivitySeckillBuyerRecord",
  components: {
    AuthButton,
    Table,
    Search
  },
  props: {
  },
  data() {
    return {
      searchForm: {
        statusList:'all'
      },
      tableKey: false,
      exportLoading: false,
      renderData: [
        {
          label: "支付状态",
          placeholder: "请选择支付状态",
          type: "select",
          key: "statusList",
          option: [
            { label: '全部', value: 'all' },
            { label: '支付完成', value: 'PaymentSuccess' },
            { label: '已退款', value: 'Refund' }
          ],
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
        {
          label: "购买时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
        {
          label: "券类型",
          placeholder: "请选择券类型",
          type: "select",
          key: "productType",
          option: [
            { label: "优惠券", value: 'Coupon', },
            { label: "礼品券", value: 'GiftCoupon', },
          ],
        },
      ],
      tableThData: [
        { prop: "couponName", label: "券名称", minWidth: "180", },
        { prop: "couponKind", label: "券类型", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "status", label: "支付状态", minWidth: "180" },
        { prop: "payTime", label: "购买时间", minWidth: "180", },
        { prop: "source", label: "来源", minWidth: "120", },
      ],
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
      couponKindMap: {
        'Coupon': '优惠券',
        'GiftCoupon': '礼品券'
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.searchForm,
        offset: this.offset,
        limit: this.limit,
        statusList: this.searchForm.statusList=='all'?'':this.searchForm.statusList,
      }
      this.searchForm.time && this.searchForm.time[0] && (params.startTime = this.searchForm.time[0])
      this.searchForm.time && this.searchForm.time[1] && (params.endTime = this.searchForm.time[1])
      delete params.time
      try {
        const data = await api_getSeckillCouponBuyRecordList(params)
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    onSearch(form) {
      this.searchForm = form
      this.offset = 0
      this.getList()
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show
      } else {
        const {phone} = await api_getUserPhone({id: row.userId})
        this.tableTrData[index].phone_show = aes.decrypt(phone)
      }
      this.tableKey = !this.tableKey
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        exportType: 'FlashCoupon',
        activityId: this.$route.query.id,
        ...this.searchForm,
        statusList: this.searchForm.statusList=='all'?'':this.searchForm.statusList,
      }
      this.searchForm.time && this.searchForm.time[0] && (params.startTime = this.searchForm.time[0])
      this.searchForm.time && this.searchForm.time[1] && (params.endTime = this.searchForm.time[1])
      delete params.time
      let res = await api_getActivityRecordExport(params)
      downFile(res)
      this.exportLoading = false
    },

    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    },
    onType(type){
      switch (type) {
        case 'PaymentSuccess':
          return '支付完成';
        case 'Refund':
          return '已退款';
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-seckill-buyerRecord {
  box-sizing: border-box;

  .el-button {
    min-width: 80px !important;
  }
}
</style>
